import { ExperienceFilterStore } from './ExperienceFilterStore';
import { ExperienceStore } from './ExperienceStore';
import { FiltersStore } from './FiltersStore';
import { LocationsStore } from './LocationsStore';
import { OfferRequestStore } from './OfferRequestStore';
import { SearchStore } from './SearchStore';
import { TranslationStore } from './TranslationStore';

const stores = {
  ExperienceStore: new ExperienceStore(),
  FiltersStore: new FiltersStore(),
  TranslationStore: new TranslationStore(),
  LocationsStore: new LocationsStore(),
  SearchStore: new SearchStore(),
  ExperienceFilterStore: new ExperienceFilterStore(),
  OfferRequestStore: new OfferRequestStore(),
};

export default {
  stores: stores,
};
